export default __webpack_public_path__ + "static/media/DV360-Logo.7edece1f.png";